<template lang="pug">
v-flex 
  v-card
    v-card-title Tipo de documentos
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar tipo de documento' single-line hide-details)
      v-form(autocomplete=false v-model='valid')
        v-dialog(v-model='state.dialog' max-width='500px')
            template(v-slot:activator='{ on }')
                v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
            v-card
                v-card-title
                    span.headline {{ title }}
                v-card-text
                    v-container(grid-list-md)
                        v-layout(wrap)
                            v-flex(xs12 sm6)
                                v-text-field(:rules='[rules.mustTwo]' v-model.number='data.code' label='Código')
                            v-flex(xs12 sm6)
                                v-text-field(v-model='data.description' label='Descripción')
                v-card-actions
                    v-spacer
                    v-btn(:disabled='!valid' color='primary' @click='(valid) ? save() : null') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items='documentTypesRecord' :search='search')
      template(v-slot:items='props')
        td {{ props.item.description }}
        td {{ props.item.code }}
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editItem(props.item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    valid: true,
    headers: [
      {
        text: 'Lista de Tipo de moneda',
        align: 'left',
        value: 'description'
      },
      { text: 'Número', value: 'number' },
      { text: 'Actions', value: 'titlename', sortable: false }
    ],
    record: [],
  }),
    methods: {
      ...mapActions({
        editItem: 'DocumentTypes/get',
        deleteItem: 'DocumentTypes/clean',
        save: 'DocumentTypes/add',
        clearForm: 'DocumentTypes/clearForm',
      }),
    },
    computed: {
      title() { return this.state.selectedKey == '' ? 'Registrar' : 'Crear' },
      titleButton() { return this.state.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        documentTypesRecord: 'DocumentTypes/record',
      }),
       ...mapState({
      rules: state=>state.Helpers.rules,
      data: state=> state.DocumentTypes.data,
      state: state=> state.DocumentTypes,
    })
  }
}
</script>
